import { IConfigFunctionArgs } from 'Components/Worksheets/Core';
import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';
import { getSieveSizeFromId } from 'Components/Worksheets/WashWorksheet/helpers';
import { get, joinPaths } from 'Lib/Object/Path/shared';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Equipment.WashingSieve`]: 'Wash Sieve',
      [`${prefix}.Equipment.GuardSieve`]: 'Guard Sieve',

      [`${prefix}.Masses.InitialDryMass`]: 'Initial Material Dry Mass',

      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Preparation.GrainSize`]: 'Wash Portion Grain Size',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DateTimePlacedInOvenLocal`]: 'Date and Time in Oven',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: 'Drying Time',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.ContainerMass`]: 'Tare Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]:
        'Tare and Portion Washed Dry Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.ConstantDrySoilMass`]: 'Portion Washed Dry Mass',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.Oven`]: 'Oven',

      [`${prefix}.Masses.WashedDryMass`]: 'Portion Washed Dry Mass',

      [`${prefix}.Results.PercentPassingWashingSieve`]: (args: IConfigFunctionArgs) => {
        const { WashingSieveSizeId: washingSieveSizeId, AllSieveSizes: allSieveSizes } =
          get(args.worksheet, joinPaths(prefix, 'Equipment')) ?? {};

        return `Finer than ${getSieveSizeFromId(washingSieveSizeId, allSieveSizes)?.Caption ?? '63 µm'} by Washing`;
      },
      [`${prefix}.Results.PercentRetainedWashingSieve`]: (args: IConfigFunctionArgs) => {
        const { WashingSieveSizeId: washingSieveSizeId, AllSieveSizes: allSieveSizes } =
          get(args.worksheet, joinPaths(prefix, 'Equipment')) ?? {};

        return `Dry Mass Retained on ${getSieveSizeFromId(washingSieveSizeId, allSieveSizes)?.Caption ?? '63 µm'}`;
      },
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.PercentPassingWashingSieve`]: '%',
      [`${prefix}.Results.PercentRetainedWashingSieve`]: '%',
    })
  );

export default getLabelConfig;
